// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"243":"styling","345":"portfolio","353":"contact"}[chunkId] + "." + {"243":"333b9536","345":"aa42b427","353":"3c0cb881"}[chunkId] + ".css";
};